import { StyleSheet, View, type ViewProps } from 'react-native';
import { type ReactNode } from 'react';

import { useTheme } from '@/theme';

import { Text } from './Text';

type Variant = 'solid' | 'wine' | 'ember' | 'verde' | 'gold' | 'ghost' | 'invert';

export type PillProps = ViewProps & {
  variant?: Variant;
  children: ReactNode;
};

export function Pill({ variant = 'solid', children, style, ...rest }: PillProps) {
  const theme = useTheme();

  const colorMap: Record<Variant, { bg: string; fg: string; border: string }> = {
    solid: { bg: theme.colors.fg, fg: theme.colors.bg, border: theme.colors.fg },
    wine: { bg: theme.colors.accent, fg: theme.colors.invert, border: theme.colors.accent },
    ember: { bg: theme.colors.accentAlt, fg: theme.colors.invert, border: theme.colors.accentAlt },
    verde: { bg: theme.colors.support, fg: theme.palette.paper, border: theme.colors.support },
    gold: { bg: theme.colors.highlight, fg: theme.palette.ink, border: theme.colors.highlight },
    ghost: { bg: 'transparent', fg: theme.colors.fg, border: theme.colors.rule },
    invert: { bg: theme.colors.bg, fg: theme.colors.fg, border: theme.colors.rule },
  };
  const c = colorMap[variant];

  return (
    <View
      style={[
        styles.pill,
        {
          backgroundColor: c.bg,
          borderColor: c.border,
          borderRadius: theme.radii.pill,
        },
        style,
      ]}
      {...rest}
    >
      <Text
        variant="eyebrow"
        style={{ color: c.fg, fontFamily: theme.fontFamily.mono }}
      >
        {children}
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  pill: {
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderWidth: 1,
    alignSelf: 'flex-start',
  },
});
